import { FHTChatId } from "@/common/FHTChatId";
import { assert } from "./assert";
export function getChatIdFromConversation(conv) {
  assert(conv, "conv is falsy!");
  assert(conv.id, "conv.id falsy");
  assert(conv.members, "conv.members falsy");
  var encodedChatId = conv.get("chatId");
  assert(typeof encodedChatId === "string", "encodedChatId if exists, must be string");
  return FHTChatId.decode(encodedChatId);
}